import React, { Component } from "react";
import { withRouter } from "react-router";


import AuthenticationService from '../../service/authentication_service';

class RightImageComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dashboard: props.dashboard,
            image: props.image
        };
    }


    logout = () => {
        AuthenticationService.clearLocalstorage();
    }
    render() {
        const {image} = this.state;
        return (
            <div className="page-ath-gfx">
                <div className="w-100 d-flex justify-content-center">
                    <div className="col-md-8 col-xl-5"><img src={image} alt="image" /></div>
                </div>
            </div>
        );
    }
}

export default withRouter(RightImageComponent);
